<template>
  <div>
    <button
      @click="toggleShow"
      :class="['mobile', 'tablet'].includes($mq) ? 'language-button-mobile' : 'language-button'"
    >
      <img
        v-if="isShow"
        src="@/assets/picto_langues.png"
        :class="['mobile', 'tablet'].includes($mq) ? 'language-picto-mobile' : 'language-picto'"
      />
      <div
        :class="['mobile', 'tablet'].includes($mq) ? 'language-text-mobile' : 'language-text'"
        style="display: flex; align-items: center"
      >
        <span>{{ this.language }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          class="ml-1 h-5 w-5 fill-current text-gray-700"
        >
          <path
            d="M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
          ></path>
        </svg>
      </div>
    </button>
    <div
      v-if="showMenu"
      :class="['mobile', 'tablet'].includes($mq) ? 'language-menu-mobile' : 'language-menu'"
    >
      <div
        class="language-menu-item"
        v-for="elem in availableLocales"
        :key="elem.value"
        @click="switchLanguage(elem)"
      >
        {{ elem.text }}
      </div>
    </div>
  </div>
</template>

<script>
import { UPDATE_USER_INFORMATIONS } from '@/store/modules/user/types'
import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'

export default {
  mixins: [userMixin, remoteConfigMixin],
  data() {
    return {
      showMenu: false,
      locale: 'fr-FR'
    }
  },
  computed: {
    availableLocales() {
      const languages = this.remoteConfig.getString('languages')
      if (languages) {
        return languages
          .split('|')
          .map(language => ({ value: language, text: this.$t(`languages.${language}`) }))
      }

      return [
        {
          value: 'en-US',
          text: 'English'
        },
        {
          value: 'fr-FR',
          text: 'Français'
        }
      ]
    },
    language() {
      return this.locale.split('-')[0].toUpperCase()
    },
    isShow() {
      return process.env.VUE_APP_APP_NAME == 'vinovibes'
    }
  },
  async created() {
    const i18nLocaleMapping = {
      'en-US': 'en',
      'fr-FR': 'fr'
    }

    if (this.user && this.user.language) {
      this.locale = this.user.language
      await this.$store.dispatch('SYNC_DATA', { locale: this.locale })
      return
    }

    const baseLocale = localStorage.getItem('language')
    const browserLocale = navigator.language || navigator.browserLanguage
    const localeMatch = this.availableLocales.find(
      el => i18nLocaleMapping[el.value] === browserLocale
    )
    this.locale = baseLocale || localeMatch.value || 'fr-FR'

    await this.$store.dispatch('SYNC_DATA', { locale: this.locale })
  },
  methods: {
    async save() {
      if (this.user) {
        await this.$store.dispatch(UPDATE_USER_INFORMATIONS, {
          language: this.locale
        })
      }
      localStorage.setItem('language', this.locale)
      await this.$store.dispatch('SYNC_DATA', { locale: this.locale })

      const i18nLocaleMapping = {
        'en-US': 'en',
        'fr-FR': 'fr'
      }

      this.$root.$i18n.locale = i18nLocaleMapping[this.locale]
      try {
        if (this.$validator.dictionary.hasLocale(i18nLocaleMapping[this.locale])) {
          this.$validator.localize(i18nLocaleMapping[this.locale])
        } else {
          import(`vee-validate/dist/locale/${i18nLocaleMapping[this.locale]}`).then(localeObj => {
            this.$validator.localize(i18nLocaleMapping[this.locale], localeObj)
          })
        }
      } catch (error) {
        console.log('error vee validate localisation', error)
      }
    },
    toggleShow() {
      this.showMenu = !this.showMenu
    },
    async switchLanguage(elem) {
      if (this.locale == elem.value) return
      else {
        this.locale = elem.value
        await this.save()
        this.showMenu = false
        // this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('forms.updatedWithSuccess') })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.language-button-mobile {
  display: flex;
  flex-direction: row;
  font-size: 16px;
  border-radius: 4px;
  border: none;
  outline: none;
  background: none;
  border-radius: 4px;
  margin-right: 30px;

  .language-picto-mobile {
    display: none;
  }

  .language-text-mobile {
    display: flex;
    flex-direction: row;
    font-size: 12px;
  }

  svg {
    overflow: visible;
  }
}

.language-button {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  border-radius: 4px;
  border: none;
  outline: none;
  background: none;
  border-radius: 4px;
  right: 85px;

  .language-picto {
    margin-top: 8px;
    margin-bottom: 5px;
    width: 30px;
    height: 30px;
  }

  .language-text {
    display: flex;
    flex-direction: row;
  }

  svg {
    overflow: visible;
  }

  &:hover {
    cursor: pointer;
  }
}

.language-menu {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  color: #212529;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 10px 0;
  padding: 8px 0;
  position: absolute;
  text-align: left;
  z-index: 20000;
}

.language-menu-mobile {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  color: #212529;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 2px 0 0;
  padding: 8px 0;
  position: absolute;
  text-align: left;
  z-index: 20000;
  right: 10px;
  // top: -10px;
}

.language-menu-item {
  color: #212529;
  padding: 4px 24px;
  z-index: 201;

  &:hover {
    background-color: #f4f6f6;
    cursor: pointer;
  }
}
</style>
